import { Switch } from "@Components/forecast/Switch";
import { useForecastAppContext } from "@Context/ForecastAppContext/ForecastAppContext";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { useAnimatedWeatherIcons } from "@Hooks/useAnimatedWeatherIcons";
import { useGeolocationName } from "@Hooks/useGeolocationName";

export const LocationDisplay = () => {
  const { forecastPointWeek } = useForecastAppContext();
  const { t } = useTranslations();
  const geolocationName = useGeolocationName(forecastPointWeek?.geolocation);
  const {
    enabled: isWeatherIconAnimated,
    setEnabled: setIsWeatherIconAnimated,
  } = useAnimatedWeatherIcons();

  return (
    <div className="m:w-full">
      <div className="m:mt-6 m:flex m:flex-col m:gap-[2px] m:px-4 m:text-xl m:font-normal m:tracking-0.4 m:text-blue-50 m:xs:mx-4 m:xs:px-0 m:md:mx-0 m:md:mt-2">
        <span className="m:sr-only">
          {t("general.a11yDescriptionLong", {
            descriptionLong: geolocationName?.description_long,
          })}
        </span>
        <span
          className="m:h-[18px] m:leading-tight m:antialiased"
          aria-hidden="true">
          {t("general.weather")}
        </span>
        <h2
          className="m:m-0 m:flex m:h-10 m:items-center m:p-0 m:text-8xl m:font-medium m:tracking-0.2 m:text-neutral-white"
          aria-hidden="true"
          data-testid="location-name">
          {geolocationName?.name}
        </h2>
        <div className="m:flex m:justify-between">
          <p
            className="m:m-0 m:h-[18px] m:p-0 m:antialiased"
            aria-hidden="true"
            data-testid="location-description">
            {geolocationName?.description_long}
          </p>
          <div className="m:lg:pr-10 m:xl:pr-14">
            <Switch
              label={t("weatherIcon.label")}
              id="animated-weather-icon"
              checked={isWeatherIconAnimated}
              onChange={(e) => setIsWeatherIconAnimated(e.target.checked)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
